import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-branch-push_svg__a"
        d="M7.857 11.013h10.345l-3.256-3.256 1.414-1.414L22.017 12l-5.657 5.657-1.414-1.414 3.23-3.23H7.835a3.001 3.001 0 11.02-2zm-2.84 1.97a1 1 0 100-2 1 1 0 000 2z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      transform="rotate(-90 12.017 12)"
      xlinkHref="#icons-branch-push_svg__a"
    />
  </svg>
);
